// 화면 콘텐츠를 컴포넌트와 분리해 문구와 프로젝트 정보를 한곳에서 관리합니다.
export const SITE = {
    brand: {
        name: "ENTSYS",
        tagline: "검증된 기술력과 실행력으로 비즈니스 성공을 만들어갑니다",
    },
    hero: {
        image: "/hero.svg",
        title: "Simple.  Clear.  Focused.",
        subtitle: "고객 비즈니스의 지속 가능한 성장을 위해, 최적화된 기술 솔루션과 전략적 컨설팅을 제공합니다.",
        ctaPrimary: "문의하기",
        ctaSecondary: "서비스 보기",
    },
    contact: {
        email: "entsyscom@gmail.com",
        phone: "010-3799-3200",
        address: "서울특별시 송파구 백제고분로 509, 대종빌딩 7층",
    },
};

export const SERVICES = [
    { title: "시스템 구축 및 운영", description: "웹/모바일 애플리케이션부터 레거시 시스템 현대화까지, React와 Spring 기반의 확장 가능한 아키텍처로 안정적인 서비스를 구축합니다." },
    { title: "IT 컨설팅 & 아웃소싱", description: "프로젝트 요구사항에 맞는 검증된 전문 인력을 매칭하고, 효율적인 개발 프로세스와 품질 관리로 고객의 리소스 최적화를 지원합니다." },
    { title: "UX/UI 디자인 & 기획", description: "사용자 리서치부터 인터페이스 설계, 프로토타이핑까지 데이터 기반의 디자인 전략으로 비즈니스 가치를 극대화합니다." },
];

export const CURRENT_PROJECTS = [
    { category: "Semiconductor · FA", title: "반도체 불량분석 시스템", period: "2026 ~ Present" },
    { category: "Semiconductor · DSP", title: "반도체 플랫폼 고도화", period: "2026 ~ Present" },
];

export const PROJECTS = [
    { category: "Semiconductor · FA", title: "반도체 분석 시스템", period: "2026 ~ Present", tech: ["React", "Node.js", "Java", "Spring Boot", "Oracle"], description: "반도체 제품의 불량 원인 분석 및 품질 업무를 지원하는 시스템 구축", image: "📦", accent: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" },
    { category: "Semiconductor · PLM", title: "반도체 제품.개발 관리 확장 전개", period: "2025 ~ 2026", tech: ["React", "Node.js", "Java", "Spring Boot", "Oracle"], description: "반도체 제품개발 데이터와 업무 프로세스를 연결하는 PLM 확장 시스템 구축", image: "📦", accent: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)" },
    { category: "Semiconductor · PLM", title: "반도체 제품.개발관리 시스템 2차 고도화", period: "2024 ~ 2025", tech: ["React", "Node.js", "Java", "Spring Boot", "Oracle"], description: "반도체 제품개발 및 업무 프로세스를 지원하는 PLM 시스템 구축(2차)", image: "💾", accent: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" },
    { category: "HR · Enterprise", title: "HR 시스템 개발", period: "2024 ~ 2024", tech: ["Vue", "Java", "Spring Boot", "Oracle"], description: "인사관리 업무 자동화 및 안정적인 운영을 위한 엔터프라이즈 시스템 고도화", image: "👥", accent: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)" },
    { category: "E-Commerce", title: "이커머스 플랫폼 개발", period: "2023 ~ 2023", tech: ["JSP", "Spring Boot", "AWS", "PostgreSQL"], description: "B2C 쇼핑몰 플랫폼과 주문·결제 핵심 시스템 개발 및 운영", image: "🛒", accent: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)" },
];

export const TECH_STACKS = {
    Frontend: [{ name: "React", icon: "⚛️" }, { name: "Vue.js", icon: "💚" }, { name: "Next.js", icon: "📱" }, { name: "TypeScript", icon: "🔷" }],
    Backend: [{ name: "Spring Boot", icon: "🍃" }, { name: "Node.js", icon: "🟢" }, { name: "Java", icon: "☕" }, { name: "Python", icon: "🐍" }],
    Database: [{ name: "Oracle", icon: "🔴" }, { name: "PostgreSQL", icon: "🐘" }, { name: "MySQL", icon: "🐬" }, { name: "MongoDB", icon: "🍃" }],
    "DevOps & Cloud": [{ name: "AWS", icon: "☁️" }, { name: "Docker", icon: "🐳" }, { name: "Kubernetes", icon: "⚓" }, { name: "Jenkins", icon: "🔧" }],
};
